import { useQuery } from "@tanstack/react-query";
import useAcquireToken from "../../AuthToken/Hooks/useAcquireToken";
import useBSTInsightsAPI from "../../../apiclients/api/bstinsightsapi";
import { RoleDTO } from "../../../apiclients/bstinsights";
import { GRID_DATA_QUERY_PREFIX } from '../../UserManagement/Hooks/utils/constants';

export const summaryTopQueryQueryKeys = "summaryTopQueryQueryKeys"

/**
 * Returns a useQuery hook for fetching summary data
 **/
const useSummaryTop = () => {
  const { getRoles, getTotalRoles } = useBSTInsightsAPI();
  const { getTokenSilently } = useAcquireToken();

  return useQuery({
    queryKey: [GRID_DATA_QUERY_PREFIX, summaryTopQueryQueryKeys],
    queryFn: async () => {
      const token: string = await getTokenSilently();
      if (!token) return;
      const result = (await getRoles(token)) as Array<RoleDTO>;
      const totalRoles = await getTotalRoles(token);
      const items = result.map((item) => ({
        id: item.roleId,
        displayname: item.roleName,
        count: item.totalAssignedUsers,
      }));
      items.unshift({
        id: totalRoles.roleId,
        displayname: totalRoles.roleName,
        count: totalRoles.totalAssignedUsers,
      });
      return items;
    },
  });
};

export default useSummaryTop;
